module.exports = __webpack_public_path__ + "img/tab_video_icon.a0d2fc19.svg";